import { JOURNAL_ADD_UPDATE } from 'constants/actionTypes';

export function addUpdateJournalEntry(journalEntry) {
  return {
    type: JOURNAL_ADD_UPDATE,
    journalEntry,
  };
}
